import { AlertColor } from "@mui/material"
import { Message, MessagePriority } from "../../../createOrderTypes"

const priorityRank: Readonly<Record<MessagePriority, number>> = {
    [MessagePriority.HIGH]: 0,
    [MessagePriority.MEDIUM]: 1,
    [MessagePriority.LOW]: 2,
}

function toMillis(date: string): number {
    const millis = Date.parse(date)
    return Number.isFinite(millis) ? millis : 0
}

export function sortMessagesByPriority(messages: ReadonlyArray<Message>): Message[] {
    return messages
        .map((message, index) => ({ message, index }))
        .sort((a, b) => {
            const rankDiff = priorityRank[a.message.priority] - priorityRank[b.message.priority]
            if (rankDiff !== 0) return rankDiff

            // Within the same priority, show newest first (stable fallback to original order)
            const dateDiff = toMillis(b.message.publishDate) - toMillis(a.message.publishDate)
            if (dateDiff !== 0) return dateDiff

            return a.index - b.index
        })
        .map(({ message }) => message)
}

export function mapMessagePriorityToAlertSeverity(priority: MessagePriority): AlertColor {
    switch (priority) {
        case MessagePriority.HIGH:
            return "error"
        case MessagePriority.MEDIUM:
            return "warning"
        case MessagePriority.LOW:
            return "info"
    }
}
